import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormGroupDirective } from '@angular/forms';
import { ProvPayerApiService } from '../../services/prov-payer-api.service';

@Component({
  selector: 'app-prov-address',
  templateUrl: './prov-address.component.html',
  styleUrls: ['./prov-address.component.css']
})
export class ProvAddressComponent implements OnInit {
  showAddress:boolean=true;
  @Input() formGroupName!: string;
  @Input() countryList : any[]=[];
  @Input() submitted : boolean=false;
  stateList:any[]=[];
  dummydata=[{
    id:1,
    name:'option1'
  },
  {
    id:2,
    name:'option2'
  },
];
dummydata1=[{
  id:"1",
  name:'option1'
},
{
  id:"2",
  name:'option2'
},
]
  addressForm!: FormGroup;
  constructor(
    private rootFormGroup: FormGroupDirective,
    private provPayerApiService:ProvPayerApiService
  ) { }

  ngOnInit(): void {
    this.addressForm = this.rootFormGroup.control.get(
      this.formGroupName
    ) as FormGroup;
  }
  selectedValue(event: any, formElem: string) {
    
    if (!event) {
      this.addressForm.controls[formElem].patchValue(null);
    }  
      this.addressForm.controls[formElem].patchValue(event);
      if(formElem == 'country'){
        this.getStateList();
      }
  }
  getStateList(){
    if(this.addressForm.value.country){
      let selectedCountryId = this.addressForm.value.country;
      this.provPayerApiService.getStateList(selectedCountryId).subscribe({
        next: (response) => { 
          if (response) {
            this.stateList = response?.data; 
          } 
        },
        error: (error) => {
          // treat error
        },
        
      }) 
    }
    
  }
}
